module.exports = __webpack_public_path__ + "media/images/lp_piramid-c20d8ea19e9c4db576595d594a594a5a.webp";